import { render, staticRenderFns } from "./ComponentTemplatesListPanel.vue?vue&type=template&id=2141d568"
import script from "./ComponentTemplatesListPanel.vue?vue&type=script&lang=js"
export * from "./ComponentTemplatesListPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports